import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { Error } from '@/components/templates/Error.tsx'
import { ScreenWrapper } from '@/components/templates/ScreenWrapper.tsx'
import { useTrackFormError } from '@/hooks/useTrackFormProgress.ts'
import { useAppointmentStore } from '@/store.ts'
import { velthuisTelNumber } from '@/utils/common.ts'

const ErrorScreen = () => {
  const navigate = useNavigate()
  const { t } = useTranslation('translation', {
    keyPrefix: 'errorScreen',
  })

  const { error, resetStore } = useAppointmentStore()
  useTrackFormError({ error: t(`messages.${error}`) })

  // Determine if we should show phone button for timeout errors
  const showPhoneButton = error === 'timeffTimeoutVelthuis'
  const phoneNumber = showPhoneButton ? velthuisTelNumber : undefined

  return (
    <ScreenWrapper>
      <Error
        error={error}
        phoneNumber={phoneNumber}
        onReset={() => {
          resetStore()
          navigate('/')
        }}
        onBack={() => navigate(-1)}
      />
    </ScreenWrapper>
  )
}

export { ErrorScreen }
